export const hasRefreshSessionArtifacts = ({
  refreshToken = null,
  csrfToken = null,
} = {}) => Boolean(refreshToken || csrfToken);

export const normalizeAuthMeState = (data = {}) => ({
  user: data.user || null,
  household: data.household || null,
  onboardingComplete: data.onboarding?.completed === true,
  onboardingStep: data.onboarding?.currentStep || 1,
  billingStatus: data.billing || null,
  features: data.features || {},
});

export const resolveRefreshPreconditionFailure = ({
  silent = false,
  refreshToken = null,
  csrfToken = null,
} = {}) => {
  const hasArtifacts = hasRefreshSessionArtifacts({ refreshToken, csrfToken });
  if (hasArtifacts) {
    return {
      shouldAbort: false,
      shouldLogout: false,
      redirect: null,
    };
  }

  if (silent) {
    return {
      shouldAbort: true,
      shouldLogout: false,
      redirect: null,
    };
  }

  return {
    shouldAbort: true,
    shouldLogout: true,
    redirect: 'session-expired',
  };
};

export const resolveAuthMeFailureAction = ({
  errorMessage,
  refreshAttemptCount = 0,
} = {}) => {
  if (errorMessage === 'ACCESS_REVOKED') {
    return {
      type: 'logout',
      redirect: 'session-expired',
    };
  }

  if (errorMessage === 'TOKEN_EXPIRED') {
    if (refreshAttemptCount >= 1) {
      return {
        type: 'logout',
        redirect: 'session-expired',
      };
    }

    return {
      type: 'refresh_retry',
      redirect: null,
    };
  }

  return {
    type: 'logout',
    redirect: 'session-expired',
  };
};
